import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FileUploadModel } from '../model/fileupload.model';
import { GenericService } from './generic.service';
import { EnvconfigService } from './envconfig.service';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService extends GenericService<FileUploadModel> {

  constructor(protected override http: HttpClient,
    private environment: EnvconfigService) {
    super(http, `${environment.get("apiURL").trim()}/configuracion/estructura`);
  }

  file1txtBytes: Uint8Array | undefined;
  file2txtBytes: Uint8Array | undefined;
  fileExceltxtBytes: Uint8Array | undefined; 
  upload(file: File): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    const req = new HttpRequest('POST', `${this.url}/upload`, formData, {
      reportProgress: true,
      responseType: 'json'
    });
    return this.http.request(req);
  }

  getFiles(): Observable<any> {
    return this.http.get(this.url + '/files');
  }
}